import { useMemo } from 'react'

const getLocale = () => navigator.language || 'es-CL'

const createCurrencyFormatter = (locale: string, currency: string = 'CLP') =>
  new Intl.NumberFormat(locale, {
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0,
    style: 'currency',
    currency,
  })

const createNumberFormatter = (locale: string) =>
  new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

export const useFormatter = () => {
  const locale = getLocale()

  const currencyFormatter = useMemo(() => createCurrencyFormatter(locale), [locale])
  const numberFormatter = useMemo(() => createNumberFormatter(locale), [locale])

  const formatCurrency = (value?: string | number, fallback = '') =>
    value ? currencyFormatter.format(Number(value)) : fallback
  const formatNumber = (value?: string | number, fallback = '') =>
    value ? numberFormatter.format(Number(value)) : fallback

  return {
    formatCurrency,
    formatNumber,
  }
}
